import { Request, Response, NextFunction } from "express";
import { PermissionService } from "../services/permission.service"; // Assuming the service is in 'services/permission.service'
import { Container } from "typedi";
import { jsonStatus, status } from "../../../utils/helpers/api.responses";


export class PermissionController {
    public permissionService = Container.get(PermissionService)

    // Create a new permission
    public createPermission = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const { name, description } = req.body;
            const t = req.t
            const newPermission = await this.permissionService.createPermission(name, t, description);
            res.status(status.Create).json({
                status: jsonStatus.Create,
                message: t('General.add_success', { field: t('Role.permissions') }),
                data: newPermission
            });
        } catch (error) {
            next(error)
        }
    }

    // Get permission by ID
    public getPermissionById = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const { id } = req.params;
            const t = req.t
            const permission = await this.permissionService.getPermissionById(id, t);
            res.status(status.OK).json({
                status: jsonStatus.OK,
                message: t('General.get_success', { field: t('Role.permissions') }),
                data: permission
            });
        } catch (error) {
            next(error)
        }
    }

    // Get all permissions with pagination and sorting
    public getAllPermissions = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const { page = 1, limit = 10, sort = {} } = req.query;
            const filters = req.query.filters ? JSON.parse(req.query.filters as string) : {};
            const t = req.t
            const permissions = await this.permissionService.getAllPermissions(filters, parseInt(page as string), parseInt(limit as string), sort, t);


            res.status(status.OK).json({
                status: jsonStatus.OK,
                message: t('General.get_success', { field: t('Role.permissions') }),
                data: permissions.data,
                total: permissions.total,
                page: permissions.page,
                totalPage: permissions.totalPage
            });
        } catch (error) {
            next(error)
        }
    }

    // Update an existing permission
    public updatePermission = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const t = req.t
            const { id } = req.params;
            const updates = req.body;
            const updatedPermission = await this.permissionService.updatePermission(id, updates, t);
            res.status(status.OK).json({
                status: jsonStatus.OK,
                message: t('General.update_success', { field: t('Role.permissions') }),
                data: updatedPermission
            });
        } catch (error) {
            next(error)
        }
    }

    // Delete permission by ID
    public deletePermission = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const t = req.t
            const { id } = req.params;
            const result = await this.permissionService.deletePermission(id, t);
            res.status(status.OK).json({
                status: jsonStatus.OK,
                message: t('General.delete_success', { field: t('Role.permissions') }),
                data: result
            });
        } catch (error) {
            next(error)
        }
    }
}
